import React from "react";
import { Canvas } from "@react-three/fiber";
import { XR, createXRStore } from "@react-three/xr";
import { WorldMover } from "./effects/WorldMover";
import { DemoSkybox } from "./scenes/DemoSkybox";
import { BlackHoleParticles } from "./effects/BlackHoleParticles";

const store = createXRStore();

const buttonStyle = {
  position: "absolute",
  bottom: "20px",
  left: "50%",
  transform: "translateX(-50%)",
  zIndex: 10,
  padding: "12px 24px",
  background: "white",
  border: "none",
  fontSize: "16px",
  fontWeight: "bold",
  cursor: "pointer",
  borderRadius: "4px",
};

const canvasWrapperStyle = { width: "100vw", height: "100vh", background: "#000" };

const WebXRDemo = () => {
  return (
    <div style={canvasWrapperStyle}>
      <button onClick={() => store.enterVR()} style={buttonStyle}>
        ENTER VR
      </button>
      <Canvas>
        <XR store={store}>
          <WorldMover>
            <DemoSkybox />
            <BlackHoleParticles />
          </WorldMover>
        </XR>
      </Canvas>
    </div>
  );
};

export default WebXRDemo;
